import { TSettings } from 'types'
import { createContext } from 'helpers'

export const { Provider: SettingsProvider, useContext: useSettingsContext } =
  createContext<TSettings>({} as TSettings)
